import React from 'react';
import {connect} from 'react-redux';
import {I18n} from 'react-redux-i18n';
import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import CircularProgress from '@material-ui/core/CircularProgress';
import {SYSTEM_MEASURE} from '../../util/SystemMeasure';

class SystemMeasure extends React.PureComponent {
  render() {
    const {
      isSaving,
      isSaved,
      onSave,
      onChangeSystemMeasure,
      systemMeasure
    } = this.props;

    return (
      <Grid item lg={7} md={10} sm={12} xs={12}>
        <ExpansionPanel defaultExpanded id="panel1">
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h3">
              {I18n.t('page.userSettings.form.systemMeasure.title')}
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Grid container>
              <Grid item md={12}>
                <RadioGroup row aria-label="systemMeasure" name="systemMeasure" defaultValue={systemMeasure} onChange={onChangeSystemMeasure}>
                  <FormControlLabel value={SYSTEM_MEASURE.METRIC} control={<Radio color="primary" />} label={I18n.t('page.userSettings.form.systemMeasure.metric')} />
                  <FormControlLabel value={SYSTEM_MEASURE.IMPERIAL} control={<Radio color="primary" />} label={I18n.t('page.userSettings.form.systemMeasure.imperial')} />
                </RadioGroup>
                <div className="admin__info-cont">
                  <Icon className="admin__info-icon">info</Icon>{I18n.t('page.userSettings.form.systemMeasure.info')}
                </div>
              </Grid>
              <Grid item md={12}>
                <div className="admin__actions">
                  {isSaved && (<div className="feedbackmsg feedbackmsg__success"><Icon className="feedbackmsg__success-icon">done</Icon>{I18n.t('page.userSettings.form.success')}</div>)
                  }
                  <Button
                    variant="contained"
                    className="btn btn-primary admin__savebt"
                    onClick={onSave}
                    id="save"
                  >
                    {isSaving && (<CircularProgress className="btn__loading btn__loading-primary  btn__floatingcirc" />)
                    }
                    {I18n.t('action.save')}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  const {i18n} = state;
  return {
    locale: i18n.locale
  };
}

export default connect(mapStateToProps)(SystemMeasure);
